var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPejlenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2",
    "data-name": "Lager 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546.89 546.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4f8e4d;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #dadada;\n        stroke-miterlimit: 10;\n        stroke-width: 36.22px;\n      }\n\n      .cls-3 {\n        fill: #dadada;\n      }\n\n      .cls-4 {\n        fill: #457d44;\n      }\n\n      .cls-5 {\n        fill: #c6c6c6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 273.44,
    cy: 273.44,
    r: 255.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.44,114.01c7.85,45.29,15.7,90.59,23.55,135.88,45.29,7.85,90.59,15.7,135.88,23.55-45.29,7.85-90.59,15.7-135.88,23.55-7.85,45.29-15.7,90.59-23.55,135.88-7.85-45.29-15.7-90.59-23.55-135.88-45.29-7.85-90.59-15.7-135.88-23.55,45.29-7.85,90.59-15.7,135.88-23.55,7.85-45.29,15.7-90.59,23.55-135.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 273.44 114.01 249.89 249.89 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 114.01 273.44 249.89 297 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 273.44 432.88 297 297 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 432.88 273.44 297 249.89 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "273.44 273.44 432.88 114.01 273.44 226.34 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 114.01 432.88 273.44 320.55 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 432.88 432.88 320.55 273.44 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "273.44 273.44 432.88 114.01 320.55 273.44 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "273.44 273.44 432.88 432.88 273.44 320.55 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.44 273.44 114.01 114.01 226.34 273.44 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "273.44 273.44 114.01 114.01 273.44 226.34 273.44 273.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "273.44 273.44 114.01 432.88 226.34 273.44 273.44 273.44"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPejlenIcon);
export default __webpack_public_path__ + "static/media/pejlen-icon.96dc5f48a19ed070b76af03a7944ccfa.svg";
export { ForwardRef as ReactComponent };